import hyRequest from '@/service'
export function usePageList(url: string) {

    const fetchGetList = (params: any) => {
        return hyRequest.post({
            url: url + `?pageSize=${params.pagesize}&pageNum=${params.page}`,
            data: params
        })   
    }

    return {
        fetchGetList
    }
}